export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', description: 'Sneaker, Sportschuhe & Luxus-Schuhe aus China' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', description: 'Hoodies, Sweater & Pullover von Top-Sellern' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line', description: 'Bedruckte & einfarbige T-Shirts' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line', description: 'Winterjacken, Windbreaker & Lederjacken' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line', description: 'Jeans, Cargohosen & Shorts' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-5-line', description: 'Caps, Beanies & Bucket Hats' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', description: 'Komplette Outfit-Sets & Bundles' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line', description: 'Unterwäsche & Basics' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line', description: 'Fußball- & Basketball-Trikots' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line', description: 'Schmuck, Uhren & Sonnenbrillen' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line', description: 'Rucksäcke, Taschen & Koffer' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link', description: 'Ledergürtel & Designergürtel' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line', description: 'Parfüm & Düfte' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', description: 'Weitere Produkte & Sonderartikel' },
];

export const brands = [
  { name: 'Nike', url: 'https://kaspreadsheet.com', imageSeq: 'brand-nike' },
  { name: 'Adidas', url: 'https://kaspreadsheet.com', imageSeq: 'brand-adidas' },
  { name: 'Jordan', url: 'https://kaspreadsheet.com', imageSeq: 'brand-jordan' },
  { name: 'Off-White', url: 'https://kaspreadsheet.com', imageSeq: 'brand-offwhite' },
  { name: 'Supreme', url: 'https://kaspreadsheet.com', imageSeq: 'brand-supreme' },
  { name: 'Stüssy', url: 'https://kaspreadsheet.com', imageSeq: 'brand-stussy' },
];

export const footerLinks = {
  editorial: [
    { name: 'Redaktionsteam', url: '#' },
    { name: 'Redaktionelle Richtlinien', url: '#' },
    { name: 'Faktenprüfung', url: '#' },
    { name: 'Aktualisierungsrichtlinie', url: '#' },
  ],
  seo: [
    { name: 'OOPBUY Spreadsheet Guide', url: '/was-ist-oopbuy-spreadsheet' },
    { name: 'QC Guide', url: '#' },
    { name: 'Shipping Guide', url: '#' },
    { name: 'Sicherheit', url: '#' },
  ],
  categories: [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', external: true },
    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', external: true },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', external: true },
    { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', external: true },
  ],
  legal: [
    { name: 'Impressum', url: '#' },
    { name: 'Datenschutz', url: '#' },
    { name: 'AGB', url: '#' },
    { name: 'Kontakt', url: '#' },
  ],
};